export default __webpack_public_path__ + "static/media/menuL_icon_05.5bc1feed.png";